import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Layout, message, Modal } from 'antd';
import { get } from 'lodash';
import AdminApi from 'services/admin';
import PdButton from 'components/pd-button';
import { PageSpinner } from 'components/page-spinner';
import DataTable from 'react-data-table-component';

import './style.scss';

const { Content } = Layout;
const { confirm } = Modal;

export function AdminList() {
  const [adminsActive, setAdminsActive] = useState([]);
  const [adminsInactive, setAdminsInactive] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);

  let currentAdmin = localStorage.getItem('current_admin');

  function findCurrentAdmin(admin) {
    let currentAdmin = localStorage.getItem('current_admin');
    return admin.email === currentAdmin;
  }

  async function getAdminListActive() {
    const { data } = await AdminApi.listAdmin(999, 'active');
    let adminList = data.data;
    let current_admin = adminList.find(findCurrentAdmin);
    let filterAdmin = adminList.filter((value) => {
      return value !== current_admin;
    });

    adminList = [current_admin, ...filterAdmin];
    setAdminsActive(adminList);
  }

  async function getAdminListInactive() {
    const { data } = await AdminApi.listAdmin(999, 'inactive');
    let adminList = data.data;
    setAdminsInactive(adminList);
  }

  async function getAdminList() {
    try {
      setLoadingPage(true);
      await getAdminListActive();
      await getAdminListInactive();
    } finally {
      setLoadingPage(false);
    }
  }

  useEffect(() => {
    getAdminList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleRestore(id) {
    try {
      if (id) {
        await AdminApi.restoreAdmin(id);
        message.success('Successfully restored admin');
      }
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getAdminList();
    }
  }

  function handleDeactivateAdmin(id) {
    confirm({
      title: 'Are you sure deactivate this admin?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        async function deactivate() {
          try {
            await AdminApi.deactivateAdmin(id);
            message.success('Successfully deactivated admin');
            getAdminList();
          } catch (err) {
            const errMessage = get(
              get(get(err, 'response', {}), 'data', {}),
              'message',
              ''
            );
            if (errMessage) {
              message.error(errMessage);
            } else {
              message.error(
                'Cannot connect to server, please check connection'
              );
            }
          }
        }
        deactivate();
      },
      onCancel() {},
    });
  }

  function handleDeleteAdmin(id) {
    confirm({
      title: 'Are you sure remove this admin?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        async function removeAdmin() {
          try {
            await AdminApi.deleteAdmin(id);
            message.success('Successfully removed admin');
            getAdminList();
          } catch (err) {
            const errMessage = get(
              get(get(err, 'response', {}), 'data', {}),
              'message',
              ''
            );
            if (errMessage) {
              message.error(errMessage);
            } else {
              message.error(
                'Cannot connect to server, please check connection'
              );
            }
          }
        }
        removeAdmin();
      },
      onCancel() {},
    });
  }

  if (loadingPage) {
    return <PageSpinner />;
  }

  const adminName = (row) => (
    <div className="table-title--data">
      <div>
        {row.first_name} {row.last_name}
      </div>
    </div>
  );

  const buttonAction = (row) => (
    <div className="button-table">
      <Row>
        {row.email === currentAdmin ? (
          <></>
        ) : (
          <>
            <Col span={12} className="button">
              {row.status === 'active' ? (
                <PdButton
                  type="danger"
                  outline
                  full
                  style={{ height: 32 }}
                  onClick={() => handleDeactivateAdmin(row.id)}>
                  Deactivate
                </PdButton>
              ) : (
                <PdButton
                  type="primary"
                  outline
                  full
                  style={{ height: 32 }}
                  onClick={() => handleRestore(row.id)}>
                  Reactivate
                </PdButton>
              )}
            </Col>
            <Col span={12} className="button">
              {row.status === 'active' ? (
                <Link
                  to={{
                    pathname: "/admins/edit", search: `id=${row.id}`,
                    data: { admin: row },
                  }}>
                  <PdButton type="primary" full style={{ height: 32 }}>
                    Edit
                  </PdButton>
                </Link>
              ) : (
                <PdButton
                  type="danger"
                  full
                  style={{ height: 32 }}
                  onClick={() => handleDeleteAdmin(row.id)}>
                  Delete
                </PdButton>
              )}
            </Col>
          </>
        )}
      </Row>
    </div>
  );

  const adminStatus = (row) => (
    <div className="status-indicator">
      <span className={row.status !== 'inactive' ? 'active' : 'hidden'}>
        {displayStatus(row.status)}
      </span>
    </div>
  );

  const columns = [
    {
      name: 'Admin',
      cell: adminName,
      width: '35%',
    },
    {
      name: 'Email',
      selector: row => row.email,
      width: '30%',
    },
    {
      name: 'Status',
      cell: adminStatus,
      width: '10%',
    },
    {
      name: '',
      cell: buttonAction,
      width: '25%',
    },
  ];

  function displayStatus(status) {
    if (status === '') {
      return '';
    } else {
      return status.charAt(0).toUpperCase() + status.slice(1);
    }
  }

  return (
    <Layout className="pd-cms-admin main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">Admins</div>
          <Content className="pageContent">
            <Row gutter={20}>
              <Col span={24}>
                <Row gutter={30} className="no-margin">
                  <Col span={7} offset={17} className=" float-right">
                    <Link to={'/admins/create'}>
                      <PdButton
                        type="primary"
                        outline
                        style={{ height: 32, width: 176 }}>
                        Add New Admin
                      </PdButton>
                    </Link>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <DataTable
                  columns={columns}
                  data={adminsActive}
                  noHeader
                  highlightOnHover
                  responsive={false}
                  striped
                />
              </Col>

              {adminsInactive.length > 0 && (
                <Col span={24} className="hidden-title-container">
                  <div className="pageTitle hiddenTitle">Inactive Admins</div>
                </Col>
              )}

              <Col span={24}>
                <DataTable
                  columns={columns}
                  data={adminsInactive}
                  noHeader
                  highlightOnHover
                  responsive={false}
                  striped
                />
              </Col>
            </Row>
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default { AdminList };
